import React from 'react';
import { useRouter } from 'next/router';
import { RouteTransitionProvider } from '../RouteTransitionProvider';
import { OnboarderContextProvider } from './OnboarderContext';
import { Router } from './Router';
import type { Role } from '@99designs/site-navigation/consts';
import type { Config } from './Config';

interface Props<T> {
    config: Config<T>;
    role: Role;
    onPageChange: (title: string, description: string) => void;
}

/**
 * Onboarder is wiring that executes the config and provides all required onboarder context
 * for each steps to work: step navigations, data store and commands.
 */
export function Onboarder<T>({ config, role, onPageChange }: Props<T>) {
    const router = useRouter();

    return (
        <OnboarderContextProvider config={config}>
            <RouteTransitionProvider location={router.asPath}>
                <Router role={role} onPageChange={onPageChange} />
            </RouteTransitionProvider>
        </OnboarderContextProvider>
    );
}
